import type { ManifestRouteDefinition } from '@/core/manifest/types'

export const dashboardManifestRoutes: ManifestRouteDefinition[] = [
  {
    key: 'dashboard',
    path: '/dashboard',
    apiCalls: [
      { url: '/tenants/users?is_active=true', method: 'GET' },
      { url: '/tenants/rbac/roles', method: 'GET' },
    ],
    lazyComponent: () =>
      import('@/features/dashboard/pages/DashboardPage').then((m) => ({
        default: m.DashboardPage,
      })),
  },
]
